(() => {
  const button = document.querySelector('[data-amaca-internal-back]');
  if (!button || !window.matchMedia('(min-width: 990px)').matches) return;

  const locale = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
  const historyKey = `amaca:internal-history:v1:${locale}`;
  const intentKey = `amaca:internal-back-intent:v1:${locale}`;
  const maximumEntries = 30;

  const normalizePath = (value) => {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return null;

    ['oseid', '_fd', 'pb', 'preview_theme_id'].forEach((parameter) => url.searchParams.delete(parameter));
    const query = url.searchParams.toString();
    return `${url.pathname}${query ? `?${query}` : ''}`;
  };

  const readHistory = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(historyKey) || '[]');
      return Array.isArray(saved) ? saved.filter((entry) => typeof entry === 'string') : [];
    } catch (_error) {
      return [];
    }
  };

  const currentPath = normalizePath(window.location.href);
  let entries = readHistory();
  let intent = null;

  try {
    intent = JSON.parse(sessionStorage.getItem(intentKey) || 'null');
  } catch (_error) {
    intent = null;
  }
  sessionStorage.removeItem(intentKey);

  if (intent?.target === currentPath && Array.isArray(intent.remaining)) {
    entries = intent.remaining.filter((entry) => typeof entry === 'string');
  } else {
    const navigationType = performance.getEntriesByType('navigation')[0]?.type;
    const previousIndex = entries.lastIndexOf(currentPath);

    if (navigationType === 'back_forward' && previousIndex >= 0) {
      entries = entries.slice(0, previousIndex);
    }
  }

  if (entries.at(-1) !== currentPath) entries.push(currentPath);
  entries = entries.slice(-maximumEntries);
  sessionStorage.setItem(historyKey, JSON.stringify(entries));

  const previousPath = entries.length > 1 ? entries.at(-2) : null;
  if (!previousPath || previousPath === currentPath) return;

  button.hidden = false;
  button.addEventListener('click', () => {
    const target = entries.at(-2);
    if (!target || target === currentPath) return;

    const remaining = entries.slice(0, -2);
    sessionStorage.setItem(intentKey, JSON.stringify({ target, remaining }));
    window.location.assign(target);
  });
})();
